import type { Stay, StaySerialized } from '@shared/types/utils';

import { parseDate } from '@shared/utils-universal/machine-date-utils';

export const getYearMonthDay = (date: Date | string) => ({
  year: parseDate(date).getFullYear(),
  month: parseDate(date).getMonth() + 1,
  day: parseDate(date).getDate(),
});

export const getStayField = (stay: Stay | StaySerialized) => {
  if (stay?.checkIn && stay?.checkOut) {
    const { checkIn, checkOut } = stay;
    return {
      checkin: getYearMonthDay(checkIn),
      checkout: getYearMonthDay(checkOut),
    };
  }
  return undefined;
};
